export default __webpack_public_path__ + "media/perfect-timing-logo.e00246bfa205e3b02d57421b65a54d25.jpeg";